"use client";

import React from "react";
import { useSession } from "next-auth/react";
import { useRouter, usePathname } from "next/navigation";
import { Button, IconButton, useMediaQuery, Tooltip } from "@mui/material";
import { PersonSearch as AdminIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

export default function AdminUserButton() {
  const { data: session, update } = useSession();
  const router = useRouter();
  const pathname = usePathname();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const hasAdminPrivileges = session?.user?.admin_tier;
  const isActive = pathname === "/admin/users";

  if (!hasAdminPrivileges || session?.impersonating) return null;

  const navigateToUserAdmin = () => {
    const event = new CustomEvent("meetingNavigationRequest", {
      detail: { href: "/admin/users" },
      cancelable: true,
      bubbles: false,
    });
    if (document.dispatchEvent(event)) {
      router.push("/admin/users");
    }
  };

  return (
    <>
      {isMobile ? (
        <Tooltip title="User Management">
          <IconButton
            color="inherit"
            onClick={navigateToUserAdmin}
            size="small"
            sx={{ ml: 1 }}
          >
            <AdminIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          variant="text"
          color="inherit"
          onClick={navigateToUserAdmin}
          startIcon={<AdminIcon />}
          sx={{
            mr: 2,
            color: theme.palette.text.secondary,
            fontWeight: isActive ? 700 : 400,
            maxWidth: 200,
          }}
        >
          User Admin
        </Button>
      )}
    </>
  );
}
